import { checkCircle, failedCircle } from "@phonero/pux-icons/icons"
import {
  PuxHeader,
  PuxIcon,
  PuxList,
  PuxProgressBar,
  PuxText,
} from "@phonero/pux-react"
import { FC } from "react"

export interface OrderStatusProps {
  statusText: string
  hasError: boolean
  orderCountTotal: number | undefined
  orderCountCompleted: number
  orderCountCancelled: number
  statusMessages: Array<string>
  isSafeToClose: boolean
  safeToCloseMessages: Array<string>
}

export const OrderStatus: FC<OrderStatusProps> = ({
  statusText,
  hasError,
  orderCountTotal,
  orderCountCompleted,
  orderCountCancelled,
  statusMessages,
  isSafeToClose,
  safeToCloseMessages,
}) => {
  const progressPercent =
    orderCountTotal === undefined || orderCountTotal === 0
      ? 0
      : (orderCountCompleted + orderCountCancelled) / orderCountTotal

  const progressState = hasError
    ? "Hidden"
    : orderCountTotal === undefined ||
      orderCountCompleted + orderCountCancelled === 0
    ? "Indeterminate"
    : "Progress"

  return (
    <>
      <PuxList style={{ textAlign: "center" }}>
        {hasError && (
          <>
            <PuxHeader>
              {
                <PuxText className={"x-large strong"}>
                  {"Bestillingen feilet"}
                </PuxText>
              }
            </PuxHeader>
            <PuxIcon
              icon={failedCircle}
              size={"large"}
              color="danger"
              className="bg-white rounded-full outline-white outline-4 outline inline-block my-8 w-48 h-48"
            />
          </>
        )}
        {!!orderCountTotal && orderCountTotal === orderCountCompleted ? (
          <>
            <PuxHeader>
              {<PuxText className={"x-large strong"}>{statusText}</PuxText>}
            </PuxHeader>
            <PuxIcon
              icon={checkCircle}
              size={"large"}
              color="primary"
              className="bg-white rounded-full outline-white outline-4 outline inline-block my-8 w-48 h-48"
            />
          </>
        ) : (
          <>
            <PuxHeader>
              {<PuxText className={"x-large strong"}>Under bestilling</PuxText>}
            </PuxHeader>
            <div className="flex items-center flex-col">
              {progressState === "Indeterminate" && (
                <PuxProgressBar
                  type="indeterminate"
                  style={{
                    maxWidth: "30rem",
                    margin: "15px",
                    marginInline: "auto",
                  }}
                />
              )}
              {progressState === "Progress" && (
                <PuxProgressBar
                  value={progressPercent}
                  style={{
                    maxWidth: "30rem",
                    margin: "2rem 5rem",
                    marginInline: "auto",
                  }}
                />
              )}
            </div>
          </>
        )}
        {statusMessages?.map((statusMessage, i) => {
          return (
            <div key={i}>
              <strong>
                <PuxText
                  style={{
                    fontSize: "1.7rem",
                    padding: "0rem",
                    textAlign: "center",
                  }}
                >
                  {statusMessage}
                </PuxText>
              </strong>
            </div>
          )
        })}
        {isSafeToClose &&
          safeToCloseMessages.map((message, i) => (
            <div key={"s-" + i}>
              <PuxText className={"large"}>{message}</PuxText>
            </div>
          ))}
      </PuxList>
    </>
  )
}
